/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const HeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Heart filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FFC220"
      d="M12 7.346C11.23 6.364 9.74 5 7.398 5 4.388 5 2 7.627 2 10.226c0 2.598 1.341 4.633 4.025 6.974 2.674 2.335 3.592 2.57 5.963 3.8 2.396-1.23 3.315-1.465 5.988-3.8C20.66 14.86 22 12.824 22 10.226 22 7.627 19.612 5 16.602 5 14.26 5 12.77 6.364 12 7.346"
      className="SVG"
    />
  </svg>
);

export const HeartFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'heart-filled-icon'}
      icon={HeartFilled}
      {...props}
      size={size}
    />
  );
};
